<template>
  <b-row>
    <b-col cols="6">
      <b-form-group label="Due Date">
        <input type="text" disabled v-model="dueDate" class="form-control" />
      </b-form-group>
    </b-col>
    <b-col cols="6" v-if="maintenanceDetailData.trigger === 'COUNTER'">
      <b-form-group label="Postpone Hours *">
        <input
          type="number"
          v-model="formPostpone.extraHours"
          class="form-control"
        />
      </b-form-group>
    </b-col>
    <b-col cols="6" v-if="maintenanceDetailData.trigger === 'CALENDAR'">
      <b-form-group label="Extra Date *">
        <input
          type="date"
          v-model="formPostpone.extraDate"
          class="form-control"
        />
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <b-form-group label="Reason *">
        <b-form-textarea
          rows="3"
          placeholder="Type Reason"
          v-model="formPostpone.reason"
        ></b-form-textarea>
      </b-form-group>
    </b-col>
    <b-col md="6" class="text-center">
      <button
        type="button"
        @click="$emit('close')"
        class="btn btn-outline-primary w-100"
        >Cancel</button
      >
    </b-col>
    <b-col md="6" class="text-center">
      <button
        type="button"
        class="btn btn-primary w-100"
        @click="savePostpone()"
        >Submit</button
      >
    </b-col>
  </b-row>
</template>

<script>
import moment from '@/node_modules/moment/moment'
import { maintenanceActions } from '@/src/Utils/helper'
export default {
  name: 'PostponeForm',
  props: {
    maintenanceDetailData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formPostpone: {
        reason: '',
        extraHours: '',
        extraDate: '',
      },
    }
  },
  computed: {
    dueDate() {
      if (this.maintenanceDetailData.trigger == 'CALENDAR') {
        console.log(this.maintenanceDetailData.dueDate)
        return moment(this.maintenanceDetailData.dueDate, 'DD-MM-YYYY').format(
          'DD/MM/YYYY'
        )
      } else {
        return this.maintenanceDetailData.dueDate
      }
    },
  },
  methods: {
    ...maintenanceActions,
    async savePostpone() {
      if (!this.formPostpone.reason) {
        return alert('Lengkapi form postpone terlebih dahulu')
      }

      let payload = {
        id: this.maintenanceDetailData.id,
        data: {
          ...this.formPostpone,
          extraDate: moment(this.formPostpone.extraDate).format('DD-MM-YYYY'),
        },
      }
      const res = await this.savePostponeMaintenance(payload)

      if (res.status === 'success') {
        this.$swal(`Postpone Berhasil`, '', 'success')
        this.$emit('close')
        this.$emit('refetch')
      } else {
        this.$swal(`Oops!`, res.data.message, 'error')
      }
    },
  },
}
</script>
